// useChatHistory - 后台薄包装层
//
// 🔁 2026-10-27：通用逻辑已迁入 @huyu/core（后台 / AI 前台共用一份源码）。
//   本文件只做两件事：① 注册后台运行时适配器；② 把调用透传给内核。
//   对外 API（返回值、字段名、方法名）与迁移前逐字兼容，页面与组件零改动。
import { useChatHistory as useCoreChatHistory } from '@huyu/core/vue'
import { ensureAiRuntime } from './aiRuntime'

export function useChatHistory(options = {}) {
  ensureAiRuntime()
  return useCoreChatHistory(options)
}
